// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector } from '@angular/core'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
import { DataService } from 'app/sd-services/DataService'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-reportSummary',
  templateUrl: './reportSummary.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class reportSummaryComponent {
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_Nw22Ac3iXxEF3NPu(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_Nw22Ac3iXxEF3NPu(bh) {
    try {
      bh = this.sd_b6NQBaV9fyYwFzdr(bh);
      //appendnew_next_sd_Nw22Ac3iXxEF3NPu
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_Nw22Ac3iXxEF3NPu');
    }
  }

  onTabChange(index: any = undefined, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { index };
      bh.local = {};
      bh = this.sd_4SFVkJTulscx7ftB(bh);
      //appendnew_next_onTabChange
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_de28j65JiiBqb7my');
    }
  }
  //appendnew_flow_reportSummaryComponent_start

  sd_b6NQBaV9fyYwFzdr(bh) {
    try {
      bh = this.sd_nZC0us9BsPK1Ci9i(bh);
      //appendnew_next_sd_b6NQBaV9fyYwFzdr
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_b6NQBaV9fyYwFzdr');
    }
  }

  sd_nZC0us9BsPK1Ci9i(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);
      this.page.searchRes = DataServiceInstance['searchRes'];
      bh = this.sd_9VcEsdQrkaZyEzZr(bh);
      //appendnew_next_sd_nZC0us9BsPK1Ci9i
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_nZC0us9BsPK1Ci9i');
    }
  }

  sd_9VcEsdQrkaZyEzZr(bh) {
    try {
      const page = this.page;
      page.selectedIndex = 0;
      page.reportTypes = [
        {
          name: 'Prefill',
          icon: 'person',
          isSelected: true,
        },
        {
          name: 'CLUE',
          icon: 'shield',
          isSelected: false,
        },
        {
          name: 'Credit',
          icon: 'payment',
          isSelected: false,
        },
        {
          name: 'Carfax',
          icon: 'directions_car',
          isSelected: false,
        },
        {
          name: 'MVR',
          icon: 'insert_drive_file',
          isSelected: false,
        },
      ];

      page.reports = {};

      for (const item of page.searchRes || []) {
        const reportName = item.report_name;
        page.reports[reportName] = item.report_data;
      }

      //appendnew_next_sd_9VcEsdQrkaZyEzZr
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_9VcEsdQrkaZyEzZr');
    }
  }

  sd_4SFVkJTulscx7ftB(bh) {
    try {
      const page = this.page;
      page.reportTypes.forEach((item, i) => {
        item.isSelected = i === bh.input.index;
      });

      page.selectedIndex = bh.input.index;
      //appendnew_next_sd_4SFVkJTulscx7ftB
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_4SFVkJTulscx7ftB');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_reportSummaryComponent_Catch
}
